import { Component, OnInit, Inject } from '@angular/core';
import { ItemConversa } from 'src/app/models/item-conversa';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ItemConversaModalComponent } from '../item-conversa-modal/item-conversa-modal.component';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-cadastrar-item-conversa-modal',
  templateUrl: './cadastrar-item-conversa-modal.component.html',
  styleUrls: ['./cadastrar-item-conversa-modal.component.scss']
})
export class CadastrarItemConversaModalComponent implements OnInit {
  item: ItemConversa;

  constructor(
    public dialogRef: MatDialogRef<CadastrarItemConversaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(this.data) {
      this.item = this.data.item;
    } else {
      this.item = new ItemConversa();
    }
  }

  salvar() {
    this.dialogRef.close(this.item);
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

}
